import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { TID } from "@/lib/testIds";

const faqs = [
  {
    q: "Who should use Bajrang Veda?",
    a: "Bajrang Veda is designed for adults (18+) — especially those with low appetite, slow weight gain, low stamina, or difficulty putting on healthy weight despite eating well. It works best when combined with a balanced diet and regular activity.",
  },
  {
    q: "How long before I see results?",
    a: "Most users start noticing improved appetite and digestion within 2–3 weeks. Visible healthy weight gain and strength improvements are typically seen over 60–90 days of consistent use.",
  },
  {
    q: "How should I consume it?",
    a: "Take 1 serving twice daily with warm milk or water, ideally 30 minutes before meals. A detailed personalised schedule is included with your free customised diet plan.",
  },
  {
    q: "Is it safe?",
    a: "Yes. Bajrang Veda is formulated using traditional Ayurvedic herbs, is 100% steroid-free and chemical-free, and is manufactured in an AYUSH-licensed facility. If you have a medical condition or take other medication, please consult a physician first.",
  },
  {
    q: "Is Cash on Delivery available?",
    a: "Yes — Cash on Delivery is available across India at ₹799. Choose COD at checkout, and our team will call you to confirm before shipping.",
  },
];

export default function FAQ() {
  return (
    <section className="relative bg-black px-5 py-16 sm:py-20">
      <div className="mx-auto max-w-3xl">
        <div className="mb-8 text-center">
          <div className="text-xs uppercase tracking-[0.3em] text-[#FF7A00]">FAQ</div>
          <h2 className="mt-2 font-display text-4xl text-white sm:text-5xl">
            Questions? <span className="text-fire">Answered.</span>
          </h2>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, idx) => (
            <AccordionItem
              key={f.q}
              value={`item-${idx}`}
              data-testid={`${TID.faqItem}-${idx}`}
              className="mb-3 overflow-hidden rounded-2xl border border-white/10 bg-white/5 px-4"
            >
              <AccordionTrigger className="py-4 text-left text-base font-medium text-white hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-4 text-sm leading-relaxed text-neutral-300">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
